import {
  Box,
  Button,
  ImageList,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { blueGrey, grey } from "@mui/material/colors";
import React, { useState } from "react";
import PDDocPreview from "./PDDocPreview";
import ShowMoreButtons from "./ShowMoreButtons";

const thresholdColors = [
  "#b6d8e3",
  "#a9d6e5", //lightest blue
  "#89c2d9", //
  "#61a5c2",
  "#468faf",
  "#2c7da0",
];

function prettyDate(dateString) {
  const [year, month, day] = dateString.split("-").map(Number);
  const date = new Date(year, month - 1, day);
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const dayOfMonth = date.getDate();
  const monthName = monthNames[date.getMonth()];
  const yearNumber = date.getFullYear();

  const getOrdinalSuffix = (day) => {
    if (day > 3 && day < 21) return "th"; // covers 11th to 20th
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  const dayWithSuffix = dayOfMonth + getOrdinalSuffix(dayOfMonth);
  return `${monthName} ${dayWithSuffix}, ${yearNumber}`;
}

function ClaimPairsByDay({ similar_comparisons_list, itemsToShow, claim_id, item }) {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.up("sm"));
  const isMd = useMediaQuery(theme.breakpoints.up("md"));
  const isLg = useMediaQuery(theme.breakpoints.up("lg"));
  const isXl = useMediaQuery(theme.breakpoints.up("xl"));

  let currentBreakpointCols = 1;
  if (isXl) currentBreakpointCols = 4;
  else if (isLg) currentBreakpointCols = 3;
  else if (isMd) currentBreakpointCols = 2;
  else if (isSm) currentBreakpointCols = 2;

  const displayedTasks =
  similar_comparisons_list.length === itemsToShow
      ? similar_comparisons_list
      : similar_comparisons_list.slice(0, itemsToShow);

  return (
    <Box
      sx={{ width: "100%", justifyContent: "left", display: "flex", border: 0 }}
    >
      <ImageList
        cols={currentBreakpointCols}
        sx={{
          height: "auto",
          overflowY: "auto",
          border: 0,
          p: 0,
          mx: 1,
          my: 1,
        }}
      >
        {displayedTasks.map((task, index) => (
          <Box
            key={index}
            sx={{
              py: 0,
              border: 2,
              borderColor: grey[400],
              borderRadius: 1,
              m: 0.5,
              bgcolor: blueGrey[100],
              position: "relative",
              overflow: "hidden",
              cursor: "pointer",
              "&:hover::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.2)",
                zIndex: 0,
              },
            }}
          >
            <PDDocPreview
              pretty_date={prettyDate(task.date)}
              key={index}
              current_task={task}
              task_index={index}
            />
          </Box>
        ))}
       
      </ImageList>

      
    </Box>
  );
}

export default ClaimPairsByDay;
